import { devtoolsExchange } from "@urql/devtools";
import { createClient, cacheExchange, fetchExchange, Exchange } from "urql";
import { CLIENT_BUILD_ID, releaseStore } from "lib/release/releaseClient";
import { releaseExchange } from "lib/release/releaseExchange";

// releaseExchange は fetch の手前に置き、cache から返る結果も含めて処理中・成功を見る
const exchangeOptions =
  process.env.NODE_ENV == "production"
    ? [releaseExchange(releaseStore, CLIENT_BUILD_ID), cacheExchange, fetchExchange]
    : [devtoolsExchange, releaseExchange(releaseStore, CLIENT_BUILD_ID), cacheExchange, fetchExchange];

export const urqlClient = createClient({
  url: `${process.env.NEXT_PUBLIC_FRONTEND_API_BASE_URL}/api/graphql_proxy`,
  exchanges: exchangeOptions as Exchange[],
  fetchOptions: () => ({
    method: "POST",
    headers: { "X-Nitoel-Client-Build": CLIENT_BUILD_ID },
  }),
  preferGetMethod: false,
});
